import { Icon } from '@natera/material/lib/icon'
import { xor } from 'lodash-es'
import { usePinnedFilters } from '~/pages/documents/model'
import { Text } from '~/shared/ui'
import type { PinnableDocumentFilterKey } from '../../../model'

export function ExpansionPanelLabel({
  filterKey,
  label,
}: {
  filterKey: PinnableDocumentFilterKey
  label: string
}) {
  const { pinnedFilters, setPinnedFilters } = usePinnedFilters()

  return (
    <div className="-ml-0.5 flex items-center gap-[11px]">
      <button
        type="button"
        className="cursor-pointer border-none bg-transparent p-0"
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
          setPinnedFilters(xor(pinnedFilters, [filterKey]))
        }}
      >
        <Icon
          className="text-primary-main text-[20px]"
          children="keep"
          fill={pinnedFilters.includes(filterKey) ? true : false}
        />
      </button>
      <Text appearance="SUBTITLE2">{label}</Text>
    </div>
  )
}
